import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "@phosphor-icons/react";

const HERO_BG = "https://customer-assets.emergentagent.com/job_exfoliating-bars/artifacts/n2tk3qz8_Photo%20Jan%2027%202026%2C%203%2052%2034%20PM.jpg";

export default function HeroSection() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center hero-bg grain-overlay"
      style={{
        backgroundImage: `url(${HERO_BG})`,
      }}
      data-testid="hero-section"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-accent text-sm md:text-base tracking-[0.3em] uppercase mb-6"
          style={{ color: '#A8C6C3', textShadow: '0 0 15px rgba(0,0,0,0.8)' }}
        >
          Real Sand. Real Clean.
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="font-heading text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[1.1] text-white mb-8"
        style={{ textShadow: '0 0 25px rgba(0,0,0,0.8), 0 0 50px rgba(0,0,0,0.4)' }}
        >
          Exfoliation Straight
          <br />
          <span className="italic font-normal" style={{ color: '#FF5A36' }}>From the Shore</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="font-body text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-12"
          style={{ color: 'rgba(248,246,240,0.8)', textShadow: '0 0 15px rgba(0,0,0,0.8)' }}
        >
          Bar soap made with activated charcoal and real beach sand.
          The deepest clean your skin has ever felt.
        </motion.p>

        <motion.a
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          href="#products"
          className="inline-flex items-center gap-3 px-10 py-4 text-sm font-accent font-semibold tracking-wider uppercase text-white transition-all duration-300 hover:brightness-110"
          style={{ backgroundColor: '#FF5A36' }}
          data-testid="hero-shop-now-btn"
        >
          Shop Now
          <ArrowDown size={18} weight="bold" />
        </motion.a>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <ArrowDown size={20} weight="regular" className="text-white/50" />
        </motion.div>
      </motion.div>
    </section>
  );
}
